var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilesList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "32px",
    viewBox: "0 0 29 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "budicon-files-tick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BondCover-Flow_Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-2",
    transform: "translate(-20.000000, -229.000000)",
    fill: "#22212A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "budicon-files-tick",
    transform: "translate(20.000000, 229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84,26.24 L3.84,5.12 L2.56,5.12 L2.56,26.88 C2.56,28.2944 3.7056,29.44 5.12,29.44 L23.04,29.44 L23.04,28.16 L5.76,28.16 C4.70016,28.16 3.84,27.29984 3.84,26.24 L3.84,26.24 Z",
    id: "Shape",
    opacity: 0.200000003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.93664,7.68 L21.11488,7.68 C20.76288,7.68 20.47616,7.39456 20.47488,7.04256 L20.45056,2.19136 L25.93664,7.68 L25.93664,7.68 Z",
    id: "Shape",
    opacity: 0.200000003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32,24.32 C7.96672,24.32 7.68,24.03328 7.68,23.68 L7.68,0.64 L5.76,0.64 C5.40672,0.64 5.12,0.92672 5.12,1.28 L5.12,26.24 C5.12,26.59328 5.40672,26.88 5.76,26.88 L26.88,26.88 C27.23328,26.88 27.52,26.59328 27.52,26.24 L27.52,24.32 L8.32,24.32 L8.32,24.32 Z",
    id: "Shape",
    opacity: 0.200000003
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.59808,7.53152 L20.6336,0.5632 C20.27392,0.20352 19.78496,0.00128 19.27552,0.00128 L5.76,0.00128 C4.70016,0.00128 3.84,0.86016 3.84,1.92128 L3.84,3.84 L1.92,3.84 C0.86144,3.84 0,4.70144 0,5.76 L0,30.08 C0,31.13856 0.86144,32 1.92,32 L22.4,32 C23.45856,32 24.32,31.13856 24.32,30.08 L24.32,28.16 L26.24,28.16 C27.29984,28.16 28.16,27.30112 28.16,26.24 L28.16,8.8896 C28.16,8.38016 27.95776,7.8912 27.59808,7.53152 L27.59808,7.53152 Z M25.93664,7.68 L21.11488,7.68 C20.76288,7.68 20.47616,7.39456 20.47488,7.04256 L20.45056,2.19136 L25.93664,7.68 L25.93664,7.68 Z M23.04,30.08 C23.04,30.43328 22.75328,30.72 22.4,30.72 L1.92,30.72 C1.56672,30.72 1.28,30.43328 1.28,30.08 L1.28,5.76 C1.28,5.40672 1.56672,5.12 1.92,5.12 L3.84,5.12 L3.84,26.24 C3.84,27.30112 4.70016,28.16 5.76,28.16 L23.04,28.16 L23.04,30.08 L23.04,30.08 Z M26.88,26.24 C26.88,26.59328 26.59328,26.88 26.24,26.88 L5.76,26.88 C5.40672,26.88 5.12,26.59328 5.12,26.24 L5.12,1.92 C5.12,1.56672 5.40672,1.28 5.76,1.28 L19.168,1.28 L19.19488,7.04768 C19.19872,8.1024 20.06016,8.96 21.11488,8.96 L26.88,8.96 L26.88,26.24 L26.88,26.24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.68032,18.97472 L11.2896,16.14848 C11.01824,15.92192 10.61504,15.95904 10.3872,16.2304 C10.16064,16.50176 10.19776,16.90624 10.46912,17.1328 L14.30912,20.3328 C14.42816,20.43264 14.57408,20.48128 14.71872,20.48128 C14.88256,20.48128 15.0464,20.41856 15.17184,20.2944 L21.57184,13.8944 C21.82144,13.6448 21.82144,13.23904 21.57184,12.98944 C21.32224,12.73984 20.91648,12.73984 20.66688,12.98944 L14.68032,18.97472 L14.68032,18.97472 Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesList);
export default __webpack_public_path__ + "static/media/files-list.1730f4feb02fff2ea6082b76081dd5d2.svg";
export { ForwardRef as ReactComponent };